import { ActivationWizard, ImportLicenseWizard, NewAWSSubscriptionWizard } from "cayo.ui.wizards";
import { NewDomainAndPartitionWizard } from "../../NewDomainAndPartitionWizard/NewDomainAndPartitionWizard";
import DatabaseConfigurationWizard from "../../Configuration/DatabaseConfigurationWizard";
import {
  ExchangeOnline,
  Smtp,
  Teams,
  ExchangeOnlineCredentials,
  TeamsCredentials,
  SmtpCredentials,
} from "../../CommunicationChannelsWizards";
import { TenantWizard } from "../../TenantWizard";
import { AzureSubscriptionWizard } from "../../AzureSubscriptionWizard";

export const clientWizardsRenderers = {
  NewManagedPartitionWizard: NewDomainAndPartitionWizard,
  CreateEXO: ExchangeOnline,
  CreateTeams: Teams,
  CreateSmtp: Smtp,
  EXOCredentials: ExchangeOnlineCredentials,
  TeamsCredentials,
  SmtpCredentials,
  ActivationWizard,
  ImportLicenseWizard,
  NewAWSSubscriptionWizard,
  NewManagedSubscriptionWizard: AzureSubscriptionWizard,
  NewManagedTenantWizard: TenantWizard,
  DatabaseConfigurationWizard,
};
